const updates = [
  { id: 1, time: '10分钟前', title: '某知名导演被曝在片场对演员进行不当行为，多名工作人员作证', tag: '新' },
  { id: 2, time: '28分钟前', title: '热门综艺录制现场突发意外，选手与导师发生激烈冲突', tag: '热' },
  { id: 3, time: '1小时前', title: '某电商平台双十一数据造假内幕被前员工曝光', tag: '' },
  { id: 4, time: '2小时前', title: '韩娱圈大地震：某顶流男团成员被曝吸毒，经纪公司紧急否认', tag: '' },
  { id: 5, time: '3小时前', title: '网红美食博主被扒后厨卫生堪忧，多家连锁店被责令整改', tag: '' },
  { id: 6, time: '5小时前', title: '某上市公司CEO朋友圈言论引发争议，股价盘中暴跌', tag: '' },
  { id: 7, time: '7小时前', title: '最新爆料：某知名游戏公司内部架构大调整，多个项目被砍', tag: '' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            实时快讯
          </h2>
          <p className="text-sm text-foreground-500 mt-2">24小时不间断更新的吃瓜快讯，一条都不错过</p>
        </div>

        <div className="max-w-3xl">
          {updates.map((item, idx) => (
            <div
              key={item.id}
              className={`relative pl-8 md:pl-10 pb-6 md:pb-7 ${
                idx < updates.length - 1 ? 'border-l-2 border-background-200' : 'border-l-2 border-transparent'
              }`}
            >
              <div className={`absolute left-0 top-0 -translate-x-1/2 w-3 h-3 rounded-full border-2 ${
                item.tag === '新' ? 'bg-accent-500 border-accent-500' :
                item.tag === '热' ? 'bg-secondary-500 border-secondary-500' :
                'bg-background-200 border-background-300'
              }`}></div>

              <div className="flex flex-col gap-1.5">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-xs text-foreground-400">{item.time}</span>
                  {item.tag && (
                    <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${
                      item.tag === '新' ? 'bg-accent-100 text-accent-700' : 'bg-secondary-100 text-secondary-700'
                    }`}>
                      {item.tag === '新' ? '最新' : '热门'}
                    </span>
                  )}
                </div>
                <p className="text-sm text-foreground-800 leading-relaxed cursor-pointer hover:text-accent-600 transition-colors">
                  {item.title}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}